import {showBackgroundAudioModal} from 'a_root-folder/lib/service/modal/templates/backgroundAudio';
import EventEmitter from 'lib/helpers/EventEmmiter';

export default class E3BackgroundAudio extends EventEmitter{
    _audioEl = null;
    _translate = null;
    _modalService = null;

    constructor(url, translate, modalService) {
        super();
        this._translate = translate;
        this._modalService = modalService;
        this.createAudioEl();
        this.setLink(url);
        this.play();
    }

    get src() {
        return this._audioEl.src;
    }

    get element() {
        return this._audioEl;
    }

    playAudio() {
        return this._audioEl.play();
    }

    play() {
        this._audioEl.oncanplaythrough = (event) => {
            var playedPromise = this._audioEl.play();
            if (playedPromise) {
                playedPromise.catch((e) => {
                    console.log(e)
                    if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
                        this._showAccessMsg((background) => {
                            if(!background) return ;
                            this._audioEl.play();
                        })
                    }
                }).then(() => {

                });
            }
        }

        this._audioEl.onplay  = (event) => {
            this._fireEvent('play' , true);
        };
    }

    pause() {
        this._audioEl.pause();
        this._fireEvent('pause' , true);
    }

    _showAccessMsg(callback){
        this._modalService.showCreatedModal('background-audio', showBackgroundAudioModal(this._translate, (background) => {
            this._modalService.close('background-audio');
            callback(background);
        }), true, undefined);
    }

    createAudioEl() {
        this._audioEl = document.createElement('audio');
        this._audioEl.autoplay = true;
        this._audioEl.loop = true;
    }

    setLink(url) {
        if (this._audioEl.canPlayType('audio/mpeg')) {
            this._audioEl.setAttribute('src', url);
        }
    }

    mute(muted) {
        this._fireEvent('mute' , muted);
        this._audioEl.muted = muted;

        return this._audioEl.muted;
    }

    destroy() {
        delete this._audioEl;
    }
}
